import React, { useEffect, useRef, useState } from 'react'
import { useFindMenu, useIsMobile, useTrans, useUtente } from '@next-nx/hooks'
import {
  WContainer,
  Breadcrumbs,
  MainTitle,
  MainDescription,
  Option,
} from '@next-nx/shared-ui/atoms'
import { Page } from '@next-nx/shared-ui/organisms'
import styles from './NltServiziInclusiTemplate.module.sass'
import { MenuItemType } from '@next-nx/utils/types'
import { BoxLink, IconTextDescriptionItem } from '@next-nx/shared-ui/molecules'
import { Swiper, SwiperSlide } from 'swiper/react'
import { Swiper as SwiperType } from 'swiper'
import { scrollTo } from '@next-nx/utils/safe'

interface Props {
  pagina?: any
}

const NltServiziInclusiTemplate = (props: Props) => {
  const { pagina = {} } = props

  const t = useTrans()
  const { utente } = useUtente()
  const toolbarPresente = utente && (utente.isStaff || utente.isImpersonate)

  const paginaServiziInclusi = useFindMenu('pagina-servizi-inclusi')
  const boxItem = paginaServiziInclusi ? useFindMenu('box-contattaci', paginaServiziInclusi) : null
  const serviziInclusi = paginaServiziInclusi
    ? useFindMenu('servizi-inclusi-list', paginaServiziInclusi)
    : null

  const [stickyBarOpen, setStickyBarOpen] = useState(false)
  const [menuActive, setMenuActive] = useState()
  const [menuSwiper, setMenuSwiper] = useState<SwiperType>()
  const [scrolling, setScrolling] = useState(false)
  const menuRef = useRef<HTMLDivElement>(null)
  const sectionRefs = useRef<HTMLDivElement[]>([])

  const addSectionRef = (ref: HTMLDivElement) => {
    if (ref) {
      if (sectionRefs.current.filter((x) => x.id === ref.id).length > 0)
        sectionRefs.current = sectionRefs.current.map((x) => (x.id === ref.id ? ref : x))
      else sectionRefs.current.push(ref)
    }
  }

  /* function scrollToElement(id: string) {
    const element = document.getElementById(id)
    if (element) {
      const offset = 144
      const bodyRect = document.body.getBoundingClientRect().top
      const elementRect = element.getBoundingClientRect().top
      const elementPosition = elementRect - bodyRect
      const offsetPosition = elementPosition - offset

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth',
      })
    }
  }

  useEffect(() => {
    let hasPassed = false
    const offset = window.innerWidth < 576 ? 80 : 100

    const handleScroll = () => {
      const myElement = document.querySelector('#filters')
      if (myElement) {
        const top = myElement.getBoundingClientRect().top - offset
        if (top <= 0 && !hasPassed) {
          setStickyBarOpen(true)
          hasPassed = true
        } else if (top > 0 && hasPassed) {
          setStickyBarOpen(false)
          hasPassed = false
        }
      }
    }

    window.addEventListener('scroll', handleScroll)

    return () => {
      window.removeEventListener('scroll', handleScroll)
    }
  }, []) */

  const handleScroll = () => {
    if (menuRef.current) {
      if (
        window.scrollY >=
        menuRef.current.offsetTop -
          (toolbarPresente ? 80 : 0) +
          menuRef.current.clientHeight -
          56 -
          20
      )
        document.body.classList.add('servizi-inclusi-menu-sticky')
      else document.body.classList.remove('servizi-inclusi-menu-sticky')
    }

    // Calcolo se sono all'altezza di un box del menu
    const scrollOffset = window.scrollY + (toolbarPresente ? 80 : 0) + 56 + 80 + 14 + 10 // + header + menu + correzzione
    const match = sectionRefs.current.filter(
      (x) => scrollOffset >= x.offsetTop && scrollOffset <= x.offsetTop + x.clientHeight
    )
    // Potrebbero esserci box sovrapposti (es. linee che va sopra a vantaggi), prendo l'ultimo match
    setMenuActive(match.length > 0 ? match[match.length - 1].id?.replace('menu_', '') : null)
  }

  useEffect(() => {
    if (menuActive && !scrolling) {
      const index = serviziInclusi?.children?.edges.findIndex((item) => item.node.pk == menuActive)
      if (index !== -1) menuSwiper?.slideTo(index)
    }
  }, [menuActive])

  useEffect(() => {
    window.addEventListener('scroll', handleScroll, { passive: true })
    return () => window.removeEventListener('scroll', handleScroll)
  }, [])

  const isMobile = useIsMobile()

  return (
    <Page pagina={pagina} className={`${styles.root}`}>
      <WContainer className={styles.row}>
        <div className={styles.col1}>
          <Breadcrumbs breadcrumbs={pagina.breadcrumbs} className={styles.breadcrumbs} />
          <MainTitle label={pagina.titolo} className={styles.title} />
          <MainDescription html={pagina.descrizione} className={styles.descrizione} />
          <div className={styles.menuSectionRef} ref={menuRef}>
            {serviziInclusi?.children?.edges.length && !isMobile && (
              <div
                className={`${styles.filtriLayout} ${styles['filtriLayout--desktop']}`}
                id="filters"
              >
                {serviziInclusi?.children?.edges?.map((x, index) => (
                  <Option
                    label={x?.node?.ctaLabel}
                    onClick={() => {
                      setScrolling(true)
                      scrollTo(sectionRefs.current[index], toolbarPresente, 14) // Offset: 56 di menu + correzione
                      setTimeout(() => setScrolling(false), 1000)
                      setMenuActive(x?.node?.pk)
                    }}
                    active={x?.node?.pk == menuActive}
                    labelClassName={styles.optionLabel}
                    key={`filters-${x?.node?.pk}`}
                  />
                ))}
              </div>
            )}

            {serviziInclusi?.children?.edges.length && (
              <div
                className={`${styles.filtriLayout} ${styles['filtriLayout--mobile']} ${styles.stickyBar}`}
                id="filters"
              >
                <Swiper
                  spaceBetween={16}
                  slidesPerView={'auto'}
                  onSwiper={(swiper) => setMenuSwiper(swiper)}
                  slideToClickedSlide={true}
                  centeredSlides
                  centeredSlidesBounds
                  initialSlide={1}
                >
                  {serviziInclusi?.children?.edges?.map((x, index) => (
                    <SwiperSlide key={`stickybar-${x?.node?.pk}`}>
                      <Option
                        label={x?.node?.ctaLabel}
                        onClick={() => {
                          setScrolling(true)
                          scrollTo(sectionRefs.current[index], toolbarPresente, 70) // Offset: 56 di menu + correzione
                          setTimeout(() => setScrolling(false), 1000)
                          setMenuActive(x?.node?.pk)
                        }}
                        active={x?.node?.pk == menuActive}
                        labelClassName={styles.optionLabel}
                      />
                    </SwiperSlide>
                  ))}
                </Swiper>
              </div>
            )}
          </div>
        </div>

        <div className={styles.col2}>
          {!!boxItem && <BoxLink item={boxItem} className={styles.box} ctaVariant={'secondary'} />}
        </div>
      </WContainer>
      <WContainer>
        {serviziInclusi?.children?.edges.length && (
          <div className={styles.serviziLayout}>
            {serviziInclusi?.children?.edges?.map((x, index) => (
              <div id={`menu_${x?.node?.pk}`} ref={addSectionRef} key={`menu-${x?.node?.pk}`}>
                <IconTextDescriptionItem item={x?.node} className={styles.item} />
              </div>
            ))}
          </div>
        )}
        <div className={`${styles.col2} ${styles['col2--mobile']}`}>
          {!!boxItem && <BoxLink item={boxItem} className={styles.box} ctaVariant={'secondary'} />}
        </div>
      </WContainer>
    </Page>
  )
}

export default NltServiziInclusiTemplate
